import { useTranslation } from 'react-i18next';
import { HiMiniArrowRight as ArrowIcon } from 'react-icons/hi2';
import { Tooltip } from '@knack/asterisk-react';

import { cn } from '@/utils/tailwind';

export function InputEditorGoToPageButton({
  onClick,
  isDisabled
}: {
  onClick: () => void;
  isDisabled?: boolean;
}) {
  const [t] = useTranslation();

  return (
    <span className="ml-2 mr-1 flex items-center">
      <span className="inline-block h-4 w-0.5 rounded-md bg-white/50" />
      <Tooltip {...(isDisabled ? { open: false } : {})}>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            className={cn(
              'ml-2 flex size-3.5 items-center justify-center rounded-full bg-white text-blue-500',
              {
                'cursor-not-allowed opacity-50': isDisabled
              }
            )}
            onClick={onClick}
            disabled={isDisabled}
          >
            <ArrowIcon size={12} />
            <span className="sr-only">{t('components.page_editor.go_to_page')}</span>
          </button>
        </Tooltip.Trigger>
        <Tooltip.Content>{t('components.page_editor.go_to_page')}</Tooltip.Content>
      </Tooltip>
    </span>
  );
}
